export default "__VITE_ASSET__BnP_aC7U__"